export default function DrinksBites() {
  const menuCategories = [
    {
      title: 'Signature Cocktails',
      icon: 'ri-goblet-line',
      color: 'cyan',
      items: [
        { name: 'Pixel Punch', price: '$12', description: 'Vodka, blue curaçao, lemonade, neon glow' },
        { name: 'High Score Margarita', price: '$11', description: 'Tequila, lime, agave, tajín rim' },
        { name: 'Power-Up Old Fashioned', price: '$14', description: 'Bourbon, bitters, orange, cherry' }
      ]
    },
    {
      title: 'Beer & Cider',
      icon: 'ri-beer-line',
      color: 'orange',
      items: [
        { name: 'Local IPA Selection', price: '$7-9', description: 'Rotating craft brews from nearby breweries' },
        { name: 'Classic Lagers', price: '$6', description: 'Crisp, cold, and always refreshing' },
        { name: 'Hard Cider', price: '$7', description: 'Sweet and tart apple goodness' }
      ]
    },
    {
      title: 'Non-Alcoholic',
      icon: 'ri-cup-line',
      color: 'pink',
      items: [
        { name: 'Retro Soda Float', price: '$6', description: 'Classic root beer with vanilla ice cream' },
        { name: 'Energy Elixir', price: '$5', description: 'Fresh fruit smoothie, power up included' },
        { name: 'Arcade Lemonade', price: '$4', description: 'House-made, perfectly tart and sweet' }
      ]
    },
    {
      title: 'Bites',
      icon: 'ri-restaurant-line',
      color: 'cyan',
      items: [
        { name: 'Loaded Pixel Fries', price: '$10', description: 'Cheese, bacon, jalapeños, sour cream' },
        { name: 'Joystick Wings', price: '$14', description: 'Buffalo, BBQ, or teriyaki glazed' },
        { name: 'Game Over Nachos', price: '$12', description: 'Chips, queso, salsa, guac, all the toppings' }
      ]
    }
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="drinks" className="relative py-24 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0d1f3c] via-[#0a1628] to-[#0d1f3c]">
        <div className="absolute top-20 right-10 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-cyan-400 mb-4">
            Drinks &amp; Bites
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-cyan-500 mx-auto mb-6"></div>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Fuel your gaming sessions with craft cocktails, local brews, and delicious bites
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {menuCategories.map((category, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#0d1f3c] to-[#0a1628] rounded-xl p-8 border border-cyan-500/20 hover:border-cyan-500/40 transition-all duration-300 hover:shadow-[0_0_30px_rgba(34,211,238,0.2)]"
            >
              <div className="flex items-center mb-6">
                <div className={`w-12 h-12 flex items-center justify-center bg-${category.color}-500/20 rounded-lg mr-4`}>
                  <i className={`${category.icon} text-2xl text-${category.color}-400`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white">{category.title}</h3>
              </div>

              <div className="space-y-6">
                {category.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="border-l-2 border-pink-500/30 pl-4 hover:border-pink-500 transition-colors duration-300">
                    <div className="flex justify-between items-start mb-2">
                      <h4 className="text-lg font-bold text-cyan-400">{item.name}</h4>
                      <span className="text-orange-400 font-bold text-lg whitespace-nowrap ml-4">{item.price}</span>
                    </div>
                    <p className="text-gray-400 text-sm">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => scrollToSection('contact')}
            className="group relative px-10 py-4 bg-gradient-to-r from-orange-500 to-pink-500 text-white text-lg font-bold rounded-lg overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(249,115,22,0.6)] hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10">See Full Menu</span>
            <div className="absolute inset-0 bg-gradient-to-r from-pink-500 to-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
        </div>
      </div>
    </section>
  );
}
